module.exports = __webpack_public_path__ + "img/rpl-class.b43e84bb.jpeg";